import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import defaultTeacher from "../img/teacher-default.avif";
import InstructorContext from "../contexts/InstructorContext";
import TextComponent from "./TextComponent";

export default function TeacherPage() {
  const [searchName, setSearchName] = useState("")
  const [searchEmail, setSearchEmail] = useState("")
  const { allTeacher } = useContext(InstructorContext);
  return (
    <div>
      {/* {/ header start /} */}
      <section>
        <div className="head-bg">
          <div className="head-overlay">
            <h1 className="text-center text-white py-7">Teachers</h1>
          </div>
        </div>
      </section>
      {/* {/ header end /} */}

      <div className="container-xxl py-4 bg-white">
        <div className="container">
          <div className="section-header text-center">
            <h2 className=" text-center px-3">Meet Our</h2>
            <h3 className="mb-4">Expert Instructors</h3>
          </div>
          <div className="container mb-4">
            <div className="row find d-flex justify-content-between">
              <div className="col-md-4 mt-4">
                <input
                  type="text"
                  className="form-control schoo-search"
                  placeholder="Search By Name"
                  value={searchName}
                  onChange={(e) => setSearchName(e.target.value)}
                />
              </div>

              <div className="col-md-4 mt-4">
                <input
                  type="text"
                  className="form-control schoo-search"
                  placeholder="Search By Email"
                  value={searchEmail}
                  onChange={(e) => setSearchEmail(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row g-4">
            {allTeacher &&
              allTeacher
                .filter((teacher) => teacher.status === "Approved").reverse().filter(teacher => teacher.name.toLowerCase().includes(searchName.toLowerCase())).filter(teacher => teacher.email.toLowerCase().includes(searchEmail.toLowerCase()))
                .map((teacher, index) => {
                  return (
                    <div
                      className="col-lg-3 col-md-6 wow fadeInUp"
                      data-wow-delay="0.1s"
                    >
                      <div className="team-item bg-light">
                        <div className="overflow-hidden">
                          <img
                            className="img-fluid teachr-img"
                            src={teacher.image ? teacher.image : defaultTeacher}
                            alt={`team-members${index}`}
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div
                          className="position-relative d-flex justify-content-center"
                          style={{ marginTop: "-23px" }}
                        >
                          <div className="bg-light d-flex justify-content-center pt-2 px-1 teacher-social">
                            <a
                              className="btn btn-sm-square  mx-1"
                              href={teacher.fbUrl}
                              target="blank"
                            >
                              <i className="fab fa-facebook-f"></i>
                            </a>
                            <a
                              className="btn btn-sm-square  mx-1"
                              href={teacher.twitterUrl}
                              target="blank"
                            >
                              <i className="fab fa-twitter"></i>
                            </a>
                            <a
                              className="btn btn-sm-square  mx-1"
                              href={teacher.instaUrl}
                              target="blank"
                            >
                              <i className="fab fa-instagram"></i>
                            </a>
                          </div>
                        </div>
                        <div className="text-center py-4">
                          <p className="bold-p mb-0">{teacher.name.length <= 13 ? teacher.name : teacher.name.slice(0, 13) + ".."}</p>
                          <small>{teacher.email}</small>
                        </div>
                        <div className="pb-3 text-center" style={{ textDecoration: '' }}>
                          <Link to={`/teacher-details/${teacher._id}`}>
                            <span style={{ fontWeight: '500', color: 'var(--secondary-color)' }}>View Details <span>&rarr;</span></span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
          </div>
          <TextComponent />
        </div>
      </div>
    </div>
  );
}
